export default __webpack_public_path__ + "static/media/discover.f656fc9f.svg";